// This component is an exact copy of libs/cameras/src/lib/components/camera-status/camera-status.component.ts
// This is a temporary solution until we can refactor the code to remove the circular dependency
// and this component will be removed once we resolve this
// TODO: https://taserintl.atlassian.net/browse/FD-276
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { SnCameraStatus } from '@lib/api/entities';

@Component({
  selector: 'fs-appliance-camera-status',
  templateUrl: './appliance-camera-status.component.html',
  styleUrls: ['./appliance-camera-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ApplianceCameraStatusComponent implements OnInit {
  @Input()
  public status: SnCameraStatus;

  public unmanagedStyles = {
    color: '#FFB028',
    borderColor: '#FFB028',
  };

  public readonly CAMERA_STATUS = SnCameraStatus;

  public ngOnInit(): void {}
}
